import * as angular from "angular";
import {IController} from "angular";

export class resourceAllocationAgentAssignmentTableCtrl implements IController {

  agentsSchedule: any;
  queryString: string;
  isShowAvailability: boolean;
  loading: boolean;
  onAssign: Function;

  /* @ngInject */
  constructor() {
  }

  onQueryChange(query) {
    this.queryString = query;
  }


}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationAgentAssignmentTable', {
    bindings: {
      agentsSchedule: '<',
      queryString: '<',
      loading: '<',
      isShowAvailability: '<',
      onAssign: '&'
    },
    template: require('./resource-allocation-agent-assignment-table.html').default,
    controller: resourceAllocationAgentAssignmentTableCtrl
  });
